import React from 'react';
import { Link } from 'react-router-dom';

interface TasksTabProps {
  tasks: any[];
  onItemSelect?: (item: any) => void;
}

const TasksTab: React.FC<TasksTabProps> = ({ tasks, onItemSelect }) => {
  const getPriorityColor = (priority: string) => {
    switch (priority) {
      case 'High':
        return 'text-danger';
      case 'Medium':
        return 'text-warning';
      case 'Low':
        return 'text-success';
      default:
        return 'text-secondary';
    }
  };

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'New':
        return 'badge bg-primary';
      case 'In Progress':
        return 'badge bg-warning';
      case 'Completed':
        return 'badge bg-success';
      default:
        return 'badge bg-secondary';
    }
  };

  if (tasks.length === 0) {
    return (
      <div className="text-center py-5">
        <div className="d-flex flex-column align-items-center">
          <i className="ti ti-checklist fs-48 text-muted mb-3"></i>
          <h5 className="text-muted">No Tasks Available</h5>
          <p className="text-muted">You don't have any pending tasks at the moment.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="table-responsive">
      <table className="table table-striped table-hover mb-0">
        <thead className="table-light">
          <tr>
            <th style={{ width: '40px' }}>
              <div className="form-check">
                <input className="form-check-input" type="checkbox" />
              </div>
            </th>
            <th>Subject</th>
            <th>From</th>
            <th>Sent Date</th>
            <th>Priority</th>
            <th>Due Date</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {tasks.map((task) => (
            <tr key={task.id}>
              <td>
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" />
                </div>
              </td>
              <td>
                <Link
                  to="#"
                  className="text-primary text-decoration-none fw-medium"
                  title={task.subject}
                  onClick={() => onItemSelect && onItemSelect(task)}
                >
                  {task.subject.length > 60
                    ? `${task.subject.substring(0, 60)}...`
                    : task.subject
                  }
                </Link>
              </td>
              <td className="text-muted">{task.from}</td>
              <td className="text-muted">{task.sentDate}</td>
              <td>
                <span className={`fw-medium ${getPriorityColor(task.priority)}`}>
                  <i className="ti ti-point-filled me-1"></i>
                  {task.priority}
                </span>
              </td>
              <td className="text-muted">{task.dueDate || '-'}</td>
              <td>
                <span className={getStatusColor(task.status)}>
                  {task.status}
                </span>
              </td>
              <td>
                <div className="d-flex align-items-center gap-2">
                  <Link
                    to="#"
                    className="btn btn-sm btn-outline-primary"
                    title="View Details"
                  >
                    <i className="ti ti-eye"></i>
                  </Link>
                  <Link
                    to="#"
                    className="btn btn-sm btn-outline-success"
                    title="Process"
                  >
                    <i className="ti ti-check"></i>
                  </Link>
                  <Link
                    to="#"
                    className="btn btn-sm btn-outline-secondary"
                    title="Forward"
                  >
                    <i className="ti ti-arrow-forward"></i>
                  </Link>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TasksTab;